// Where the sun is for a given moment and place (low-precision almanac
// formulas, good to a fraction of a degree).
const RAD = Math.PI / 180;

// Returns { altitude, azimuth } in radians. Azimuth is measured from north, turning east.
export function sunPosition(date, lat, lon) {
  const d = (date.getTime() - Date.UTC(2000, 0, 1, 12)) / 86400000;
  const L = (280.46 + 0.9856474 * d) % 360;
  const g = ((357.528 + 0.9856003 * d) % 360) * RAD;
  const lambda = (L + 1.915 * Math.sin(g) + 0.02 * Math.sin(2 * g)) * RAD;
  const eps = (23.439 - 0.0000004 * d) * RAD;
  const ra = Math.atan2(Math.cos(eps) * Math.sin(lambda), Math.cos(lambda));
  const dec = Math.asin(Math.sin(eps) * Math.sin(lambda));
  const gmst = (18.697374558 + 24.06570982441908 * d) % 24;
  const ha = (gmst * 15 + lon) * RAD - ra;
  const phi = lat * RAD;
  const altitude = Math.asin(Math.sin(phi) * Math.sin(dec) + Math.cos(phi) * Math.cos(dec) * Math.cos(ha));
  const azimuth = Math.atan2(-Math.sin(ha), Math.tan(dec) * Math.cos(phi) - Math.sin(phi) * Math.cos(ha));
  return { altitude, azimuth };
}

// Unit vector toward the sun in game axes (x east, y up, z south).
export function sunDirection(date, lat, lon) {
  const { altitude, azimuth } = sunPosition(date, lat, lon);
  const c = Math.cos(altitude);
  return [Math.sin(azimuth) * c, Math.sin(altitude), -Math.cos(azimuth) * c];
}
